import IAMConfig from '../../pages/iam-config/index.vue'
import Landing from '../../pages/Landing.vue'
import PackageDetails from '../../pages/package-details/index.vue'
import PackageView from '../../pages/package-view/index.vue'
import RequestFilters from '../../pages/request-filter/index.vue'
import type { RouteRecordRaw } from 'vue-router'
import SidePanel from '../../components/layout/SidePanel.vue'
import WorkersFilter from '../../pages/workers-filter/index.vue'
import WorkloadDetails from '../../pages/workload-details/index.vue'
import AuditLogs from '../../pages/audit-logs/index.vue'
import DependencyGraph from '../../pages/dependency-graph/index.vue'
import QualityGates from '../../pages/quality-gates/index.vue'
import QualityGateDetails from '../../pages/quality-gates/details.vue'
import { requireAuth } from '../middleware/auth'

export const mainRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: SidePanel,
    beforeEnter: requireAuth,
    children: [
      { path: '', component: Landing },
      { path: '/request-filter', component: RequestFilters },
      { path: '/workers-filter', component: WorkersFilter },
      { path: '/iam-config', component: IAMConfig },
      { path: '/audit-logs', component: AuditLogs },
      { path: '/dependency-graph', component: DependencyGraph },
      { path: '/packages', component: PackageView },
      { path: '/packages/:packageName', component: PackageDetails },
      { path: '/packages/:packageName/:version', component: PackageDetails },
      { path: '/workload/:gitRepo/:workload/:environment', component: WorkloadDetails },
      { path: '/quality-gates', component: QualityGates },
      { path: '/quality-gates/:repo/:prNumber', component: QualityGateDetails }
    ]
  }
]
